/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/require-default-props */
import { CardType } from '@amzn/cuminuicomponents';
import { KatDivider, KatIcon } from '@amzn/katal-react';
import PinIcon from 'public/images/icons/pin.svg';
import React, { useState } from 'react';
import { useAppSelector } from 'src/redux/hooks';
import { SearchType, selectSearch } from 'src/redux/slices/postSearch';
import { AppState } from 'src/redux/store';
import { Post } from 'src/types/Search';
import { isStatusLoading, useTranslation } from 'src/utils';
import SearchListingPost from './SearchListingPost';

export interface PinnedPostContainerProps { }

const PinnedPostContainer: React.FC<PinnedPostContainerProps> = () => {
  const { posts, status: fetchStatus } = useAppSelector(
    (state: AppState) => selectSearch(state, SearchType.pinnedThreads),
  );
  const [isPinnedExpanded, setIsPinnedExpanded] = useState(false);

  const { t } = useTranslation();

  if (
    (posts && posts.length === 0)
    || (isStatusLoading(fetchStatus))
  ) {
    return null;
  }
  // Note: Hard-coding post count to 1 until https://sim.amazon.com/issues/SPCE-8669
  // is resolved.
  const pinnedPostMessage = t('pinThread_pinnedByModerator', { postCount: 1 });
  const containerStyles = [
    'border', 'border-solid', 'border-kat-seattle', 'border-l-[6.5px]',
  ];

  if (posts && posts.length === 1) {
    const firstPostIndex = 0;
    const post = posts[firstPostIndex];
    containerStyles.push('mb-1');
    containerStyles.push(post.isAmazonReplied ? 'border-l-kat-persimmon' : 'border-l-kat-lake');
    return (
      <div
        data-testid="searchListing-pinned-post-container"
        className={containerStyles.join(' ')}
      >
        <div className="border border-solid border-kat-seattle border-x-transparent border-t-transparent bg-custom-orange py-1.5 px-8">
          <div className="flex flex-row items-center text-kat-nordic">
            <img src={PinIcon.src} alt="pin" />
            <span className="ml-0.5" />
            {pinnedPostMessage}
          </div>
        </div>
        <SearchListingPost
          cardType={CardType.pinnedSearch}
          key={post.postId}
          post={post}
          postIndex={firstPostIndex}
        />
      </div>
    );
  }
  return (
    <div data-testid="searchListing-pinned-post-container" className="flex flex-col">
      <button
        className={`cursor-pointer border border-solid bg-custom-orange py-1.5 px-8 ${isPinnedExpanded ? 'border-kat-persimmon' : 'border-kat-seattle'}`}
        onClick={() => setIsPinnedExpanded(!isPinnedExpanded)}
        type="button"
      >
        <div className="flex flex-row items-center justify-between text-kat-nordic">
          <div>
            <img src={PinIcon.src} alt="pin" />
            <span className="ml-0.5" />
            {pinnedPostMessage}
          </div>
          <div
            className="border-0 bg-transparent p-0 pt-0.5"
            data-testid="pinned-post-container-expansion-button"
          >
            <KatIcon data-testId="pinned-expanded-icon" name={isPinnedExpanded ? 'expand_less' : 'expand_more'} size="small" />
          </div>
        </div>
      </button>
      {posts && isPinnedExpanded && posts.map((post: Post, index: number) => {
        containerStyles.push('border-y-0', 'last:border-b', 'last:border-b-kat-seattle');
        containerStyles.push(post.isAmazonReplied ? 'border-l-kat-persimmon' : 'border-l-kat-lake');
        return (
          <div className={containerStyles.join(' ')} key={post.postId}>
            <div className="bg-kat-white">
              {
              index > 0 && <KatDivider className="my-0 mx-5 bg-kat-seattle" />
            }
            </div>
            <SearchListingPost
              cardType={CardType.pinnedSearch}
              key={post.postId}
              post={post}
              postIndex={index}
            />
          </div>
        );
      })}
    </div>
  );
};
export default PinnedPostContainer;
